import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailHeaderPriceCss from '../../assets/header/header-price.module.scss';
import { useBaseContext } from '#base/hooks';

const HeaderPrice: FC = () => {
  const { isBot } = useBaseContext();
  const {
    advert: {
      price,
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return null;
  }

  if (!price) {
    return null;
  }

  return (
    <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice}>
      <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice__value}>
        {price}
      </div>
      <div className={advertDetailHeaderPriceCss.advertDetailHeaderPrice__label}>
        <FormattedMessage defaultMessage="hour rate" />
      </div>
    </div>
  );
};

export { HeaderPrice };
